import request from '@/utils/request'

const baseUrl = '/notif'

export async function SendTelegram(msg: string) {
  return request.post(`${baseUrl}/telegram/?message=${msg}`)
}

export interface TelegramConfig {
  botName: string
  botToken: string
  chatName: string
  chatID: number
}

export async function GetTelegramConfig(): Promise<TelegramConfig> {
  return request.get(`${baseUrl}/telegram`)
}

export async function PatchTelegramConfig(
  cfg: TelegramConfig
): Promise<TelegramConfig> {
  return request.patch(`${baseUrl}/telegram`, cfg)
}
